import React from 'react';

type Props = {
    classes         : string
    iconTabOption   : Option
    onChangeTab     : callback
}

export default function IconSelectorTab(props: Props) {

    const onChangeTab = ()=> {
        props.onChangeTab(props.iconTabOption.value)
    }

    return (
        <div className={props.classes} onClick={onChangeTab}>
            <div className="label">{props.iconTabOption.label}</div>
        </div>
    );
}
